import { Model } from "@vuex-orm/core";
import { required, maxLength } from "vuelidate/lib/validators";

export default class Supplier extends Model {
  static entity = "suppliers";

  static $fetch() {
    return this.api().get('Suppliers/')
  }
  static $get (id) {
    return this.api().get(`Suppliers/${id}/`)
  }
  static $post (data) {
    return this.api().post(`Suppliers/`, data)
  }
  static $put (id, data) {
    return this.api().put(`Suppliers/${id}/`, data)
  }

  static fields() {
    return {
      id: this.attr(null),
      name: this.string(""),
      icon: this.string("fas fa-shopping-basket"),
      label: this.string("Supplier"),
      hint: this.string(
        "Not necessarily the manufacturer...can be the distributor of the material"
      ),
      counter: this.number(64)
    };
  }

  toCreatePayload() {
    return {
      name: this.name
    };
  }

  toUpdatePayload() {
    return {
      ...this.toCreatePayload(),
      id: this.$id
    };
  }

  static get validations() {
    return {
      formdata: {
        name: { required, maxLength: maxLength(64) }
      }
    };
  }
}

